import BigNumber from 'bignumber.js'
import React, {useState,useEffect,useCallback} from 'react'
import styled from 'styled-components'
import useI18n from 'hooks/useI18n'
import { useWallet } from '@binance-chain/bsc-use-wallet'
import { Text, Link, ButtonMenu, ButtonMenuItem } from '@pancakeswap-libs/uikit'
import UnlockButton from 'components/UnlockButton'
import Page from 'components/layout/Page2'
import { getTokenAddressFromQuery } from 'utils/sep20FactoryUtils'
import Hero from './components/Hero'
import Create from './components/Create'
import Successful from './components/Successful'
import My from './components/My'
import Explorer from './components/Explorer'
import { useMySep20Tokens, useRecentSep20Tokens } from './hooks/useSep20Factory'

const Wrapper = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 25px 0px 35px 0px;
`

const Container = styled.div`
    text-align: center;
`

const BenLock = () => {
    const TranslateString = useI18n();
    const { account } = useWallet();
    const [activeIndex, setActiveIndex] = useState(getTokenAddressFromQuery()?1:0);
    const [mySep20Page, setMySep20Page] = useState(1);
    const mySep20Tokens = useMySep20Tokens(mySep20Page);
    const [recentTokenPage, setRecentTokenPage] = useState(1);
    const recentTokens = useRecentSep20Tokens(recentTokenPage);

    const handleClick = (index) => {
        setActiveIndex(index)
    }

    const [showSuccess, setShowSuccess] = useState(false);

    const renderCreateView = () => {
        if (showSuccess) {
            return (<Successful onConfirm={()=>{setShowSuccess(false)}}/>);
        }

        return (<Create onSuccess={()=>{setShowSuccess(true)}} />);
    }

    return (
        <>
        <Hero/>
        <Page>
            <Wrapper>
                <ButtonMenu activeIndex={activeIndex} onClick={handleClick} size="sm" variant="subtle">
                    <ButtonMenuItem>{TranslateString(308,'Create')}</ButtonMenuItem>
                    <ButtonMenuItem>{TranslateString(309,'Explorer')}</ButtonMenuItem>
                    <ButtonMenuItem>{TranslateString(407,'My Tokens')}</ButtonMenuItem>
                </ButtonMenu>
            </Wrapper>
            {activeIndex===0 && (account? renderCreateView():<Container><UnlockButton/></Container>)}
            <div style={activeIndex===1?{}:{display:"none"}}>
                <Explorer tokens={recentTokens} account={account} setPage={setRecentTokenPage} />
            </div>
            {activeIndex===2 && (account? <My tokens={mySep20Tokens} account={account} setPage={setMySep20Page}/>:<Container><UnlockButton/></Container>)}
        </Page>
        </>
    )
}

export default BenLock
